import React from "react";
import { BRAND } from "@/lib/brand";

export default function Founders() {
  return (
    <section data-testid="founders-section" id="founders" className="py-16 md:py-24 bg-bone">
      <div className="container-x grid grid-cols-12 gap-10 items-center">
        <div className="col-span-12 lg:col-span-6">
          <div className="rounded-3xl overflow-hidden shadow-card bg-white border border-navy/10">
            <img src={BRAND.founderPhoto} alt="Saki and Bibek — founders of Velixa Health, in uniform" className="w-full h-auto object-contain" loading="lazy" />
          </div>
        </div>
        <div className="col-span-12 lg:col-span-6">
          <div className="text-[13px] font-bold uppercase tracking-widest text-brand">Meet the Founders</div>
          <h2 className="mt-3 text-[32px] md:text-[44px] font-extrabold text-navy leading-[1.1]">
            Two nurses from <span className="text-brand">Manipal Hospitals</span>, now caring for Bangalore at home.
          </h2>
          <p className="mt-5 text-ink/85 text-[17px] leading-relaxed max-w-xl">
            Saki and Bibek began their careers as nurses at Manipal Hospitals, where they saw how much patients need good care after they go home. Velixa Health is their answer — a small, local team that treats every home visit like a ward round: prepared, hygienic, and personal.
          </p>
          <div className="mt-7 grid grid-cols-2 md:grid-cols-3 gap-4">
            <div><div className="text-[11px] uppercase tracking-widest text-brand font-bold mb-1">Practice</div><div className="font-semibold text-navy">Nursing · Home Care</div></div>
            <div><div className="text-[11px] uppercase tracking-widest text-brand font-bold mb-1">Education</div><div className="font-semibold text-navy">BSc Nursing</div></div>
            <div><div className="text-[11px] uppercase tracking-widest text-brand font-bold mb-1">Based in</div><div className="font-semibold text-navy">Whitefield · Bangalore</div></div>
          </div>
        </div>
      </div>
    </section>
  );
}
